import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import { formatDuration } from 'shared/time';
import { truncate } from 'shared/utility';

import { ReactComponent as PlayAlt } from 'assets/icons/play@2x.svg';
import { ReactComponent as Lock } from 'assets/icons/lock.svg';

import styles from './Lesson.module.scss';

import { shouldOpenPurchaseModal } from 'utils/inAppPurchaseUtils';
import { useModals } from 'context/modal/useModals';

const Lesson = ({ search, data, history, showModal }) => {
    const [width] = useState(window.innerWidth);

    const modals = useModals();

    const navigate = (to = '/home', episode) => {
        episode?.locked
            ? shouldOpenPurchaseModal(
                  episode,
                  modals,
                  () => {
                      showModal('lessons');
                  },
                  to,
                  search
              )
            : history.push(to);
    };

    return (
        <div
            className={styles.lesson}
            onClick={() => navigate(`/lessons/${data.id}`, data)}
        >
            <div className={styles.container}>
                {data.locked ? <Lock /> : <PlayAlt />}
                <div
                    className={styles.image_container}
                    style={{
                        backgroundImage: `url(${(data.hero_image &&
                            data.hero_image.url) ||
                            (data.thumbnail && data.thumbnail.url)})`,
                    }}
                >
                    {data.locked && <div className={styles.mask}></div>}
                </div>
            </div>
            <div
                className={styles.card_content}
                style={{ opacity: data.locked ? '0.5' : '1' }}
            >
                <div className={styles.subhead}>
                    {data.subhead && (
                        <span>
                            {data.subhead &&
                                truncate(data.subhead, width < 1439 ? 18 : 25)}
                        </span>
                    )}
                    <span className={styles.duration}>
                        {formatDuration(data.duration)}
                    </span>
                </div>
                <div className={styles.title}>{data.title}</div>
            </div>
        </div>
    );
};

export default withRouter(Lesson);
